module.exports = __webpack_public_path__ + "static/media/conack-new.60508bf5.png";